<template>
  <div class="h-full overflow-hidden">
    <!-- 搜索条件 -->
    <div>
      <div class="flex mb-5px">
        <div class="icon-search__input ml-2px">
          <el-input
            placeholder="缺陷名称"
            v-model="defectName"
            size="small"
            clearable
            @keypress.enter.native="currentChange(1)"
          >
            <i slot="append" class="el-icon-search cursor-pointer" @click="currentChange(1)"></i>
          </el-input>
        </div>
        <el-select
          v-model="defectType"
          size="medium"
          placeholder="缺陷类型"
          clearable
          ref="fatherNode"
          @clear="handleClear"
        >
          <el-option></el-option>
        </el-select>
      </div>
      <div class="flex mb-5px">
        <el-date-picker v-model="date"></el-date-picker>
        <el-button class="text-white ml-10px" @click="openDefectTrendDialog">缺陷趋势</el-button>
      </div>
    </div>
    <!-- 设备缺陷记录 -->
    <el-table
      :data="docTableData"
      :height="`calc(100% - 130px)`"
      highlight-current-row
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-table-column
        prop="pointName"
        label="序号"
        min-width="20"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="pointName"
        label="缺陷名称"
        min-width="45"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="pointName"
        label="状态"
        min-width="45"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="value1"
        label="缺陷类型"
        min-width="30"
        align="center"
      ></el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
      class="mt-10px flex justify-center"
      background
      @current-change="currentChange"
      @size-change="sizeChange"
      :current-page="initPagination.pageNum"
      :page-size="initPagination.pageSize"
      layout="total, prev, pager, next"
      :total="initPagination.total"
      :pager-count="5"
    >
    </el-pagination>

    <defect-trend-dialog
      v-if="defectTrendVisible"
      @close="closeDefectTrendDialog"
    ></defect-trend-dialog>
  </div>
</template>

<script>
import { DevicePointRelationApi } from '@wiz-api/tag-management'
import { IotApi } from '@wiz-api/measuring-point-management'
import categoryTitle from '@/components/cockpit/CategoryTitle'
import CardTitle from '@/components/cockpit/CardTitle'
import DefectTrendDialog from './components/DefectTrendDialog'

const devicePointRelationApi = new DevicePointRelationApi()
const iotApi = new IotApi()
const signalR = require('@microsoft/signalr')

export default {
  name: 'DeviceRealTimeInfo',
  components: {
    DefectTrendDialog,
  },
  props: {
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
  },
  data() {
    return {
      docTableData: [],
      defectName: '',
      defectType: '',
      date: new Date(),
      initPagination: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      defectTrendVisible: false,
    }
  },
  watch: {},
  computed: {},
  methods: {
    currentChange() {},
    // 清空缺陷类型事件
    handleClear() {},
    // 每页条数改变事件
    sizeChange() {},
    openDefectTrendDialog() {
      this.defectTrendVisible = true
    },
    closeDefectTrendDialog() {
      this.defectTrendVisible = false
    },
  },
  created() {},
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table {
    font-size: 13px;
    .cell {
      line-height: 14px;
    }
  }
}

::v-deep {
  .info-form {
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-form-item__label {
      line-height: 20px;
      padding-bottom: 5px;
    }
    .el-input {
      .el-input__inner {
        border-color: #fff !important;
      }
    }
  }
}

::v-deep {
  .el-button {
    color: #fff !important;
  }
}
</style>
